<div class="event-role-sheet">
  <span class="sheet-grab" aria-hidden="true"></span>
  <h2 class="sheet-title">{{ 'event-access.roles.group' | translate }}</h2>
  <div class="role-options" role="list">
    @for (option of options; track option.role) {
    <button
      type="button"
      role="listitem"
      class="role-option"
      [class.is-active]="option.active"
      [attr.aria-current]="option.active ? 'true' : null"
      (click)="select(option.role)"
    >
      <ion-icon class="role-icon" [name]="option.icon" aria-hidden="true" />
      <span class="role-label">{{ option.labelKey | translate }}</span>
      @if (option.active) {
      <ion-icon class="role-check" name="checkmark-outline" aria-hidden="true" />
      }
    </button>
    }
  </div>
</div>
